import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import { FONTS, textLG, textSM } from '@styles/fonts'
import styled from 'styled-components'

export const ListingEnquiry = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 32px;

  @media ${DEVICES.tabletMini} {
    padding-top: 54px;
  }
`

export const ListingEnquiryImage = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background-color: ${COLORS.primary};
  color: ${COLORS.nature.base};
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${FONTS.bold};
  ${textLG};
  letter-spacing: 1.2px;
  margin-right: 20px;

  img {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    object-fit: cover;
  }
`

export const ListingEnquiryContent = styled.div`
  h1 {
    ${textLG};
    letter-spacing: 1.2px;
    margin-bottom: 0;
    font-family: ${FONTS.medium};

    strong {
      font-family: ${FONTS.medium};
    }
  }
`

export const Auction = styled.div`
  ${textSM};
  letter-spacing: 1px;
  padding-top: 8px;
  color: ${COLORS.primary};

  span {
    font-family: ${FONTS.bold};
    text-transform: uppercase;
  }
`
